import { render, staticRenderFns } from "./Watchdog.vue?vue&type=template&id=f2c318ce&"
import script from "./Watchdog.vue?vue&type=script&lang=js&"
export * from "./Watchdog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports